import React from 'react'

export function PanelPatientDataDisplay({ title, value }) {
  return (
    <div className={'d-flex flex-column mb-2'}>
      <div className={'data-display-label'}>{title}</div>
      <div className={'data-display-value'}>{value || '-'}</div>
    </div>
  )
}
